import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=24ea2ddf&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ea2ddf')) {
      api.createRecord('24ea2ddf', component.options)
    } else {
      api.reload('24ea2ddf', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=24ea2ddf&", function () {
      api.rerender('24ea2ddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ct3aCbIB7dap/JS/comp/openstreetmap.vue"
export default component.exports